<div class="overdraft-account-actions-dialog">
  <div>
    <mat-dialog-content class= 'max-height-100-vh'>
      <application-stepper2 [linear]="false"
        [showErrorDetailsInPopup]="true"
        [showHeader]="false"
        #applicationStepper="applicationStepper2">
        <cdk-step [stepControl]="formGroupStep1" ><ng-content *ngTemplateOutlet="step1" ></ng-content></cdk-step>
        <cdk-step [stepControl]="formGroupStep2" ><ng-content *ngTemplateOutlet="step2" ></ng-content></cdk-step>
        <cdk-step [stepControl]="formGroupStep3" ><ng-content *ngTemplateOutlet="step3" ></ng-content></cdk-step>
      </application-stepper2>
    </mat-dialog-content>
  </div>
</div>


<!--
##########################################
#  STEP 1: Select Opportunity
##########################################
-->
<ng-template #step1>
  <div class="step1">
    <form [formGroup]="formGroupStep1">
      <div class="row">
        <div class="col-12">
          <div class="mat-subtitle-1 header">Select Opportunity</div>
        </div>
      </div>
      <div class="row">
        <div class="col-8">
          <mat-form-field>
            <mat-label>Opportunity</mat-label>
            <mat-select placeholder="Select Opportunity..." [formControl]="formControlStep1Opportunity">
              @if (!opportunitySelections.length) {
                <mat-option [value]="null">No existing overdraft opportunity</mat-option>
              }
              @for (option of opportunitySelections; track option) {
                <mat-option [value]="option">{{option.Name}} (Amount: {{option.Amount | looseCurrency}} Opportunity Id: {{option.SalesforceId}})</mat-option>
              }
            </mat-select>
            @for (errorKey of errorKeys(formControlStep1Opportunity); track errorKey) {
              <mat-error>
                @if (formControlStep1Opportunity.touched && formControlStep1Opportunity.hasError(errorKey)) {
                  {{errorMessage(formControlStep1Opportunity, errorKey)}}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        @if (selectedOpportunity) {
          <div class="col-4">
            <message-box-2 type="info" [title]="getActionTypeLabel()" class="action-type-message-box">
            </message-box-2>
          </div>
        }
      </div>
    </form>
  </div>


</ng-template>

<!--
##########################################
#  STEP 2: Account Action Details
##########################################
-->
<ng-template #step2>
  <div class="step2">
    <form [formGroup]="formGroupStep2" >
      <div class="row">
        <div class="col-12">
          <div class="mat-subtitle-1 header">{{getActionTypeLabel()}} Details</div>
        </div>
      </div>
      @if (actionType === 'increase' || actionType === 'decrease' || actionType === 'increase+renewal' || actionType === 'decrease+renewal') {
        <div class="row">
          <div class="col-6">
            <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
              <div>Current Limit</div>
              <div class="postfix-icon-padding">
                {{getCurrentLimit() | looseCurrency}}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
              <div>{{getLimitChangeLabel()}}</div>
              <div class="postfix-icon-padding">
                {{formControlStep2OverdraftLimit.value | looseCurrency}}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
              <div>{{actionType === 'decrease' || actionType === 'decrease+renewal' ? 'Limit Decrease Amount' : 'Limit Increase Amount'}}</div>
              <div class="postfix-icon-padding">
                {{getLimitChangeDelta() | looseCurrency}}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
              <div>Facility Establishment Fee</div>
              <div class="postfix-icon-padding">
                {{formControlStep2FacilityEstablishmentFee.value | looseCurrency}}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
              <div>Rate</div>
              <div class="postfix-icon-padding">
                {{formControlStep2Rate.value | number : '1.2-2' | percentage}}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
              <div>Margin</div>
              <div class="postfix-icon-padding">
                {{formControlStep2Margin.value | number : '1.2-2' | percentage}}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
              <div>Documentation Fee</div>
              <div class="postfix-icon-padding">
                {{formControlStep2DocFee.value | looseCurrency}}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
              <div>Doc Fee Financed</div>
              <div class="postfix-icon-padding">
                {{formControlStep2DocFeeFinanced.value ? 'Yes' : 'No'}}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
              <div>Brokerage</div>
              <div class="postfix-icon-padding">
                {{formControlStep2Brokerage.value | looseCurrency}}
              </div>
            </div>
          </div>
          @if (earlyTerminationFee > 0) {
            <div class="col-6">
              <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
                <div>Early Termination Fee</div>
                <div class="postfix-icon-padding">
                  {{earlyTerminationFee | looseCurrency}}
                </div>
              </div>
            </div>
          }
        </div>
      }

      @if (actionType === 'renewal' || actionType === 'increase+renewal' || actionType === 'decrease+renewal') {
        <div class="row">
          <div class="col-12">
            <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
              <div>Renewal</div>
              <div class="postfix-icon-padding">
                This action includes account renewal
              </div>
            </div>
          </div>
        </div>
      }

      <div class="row">
        <div class="col-12">
          <div class="mat-subtitle-1 header">Customer Bank Details</div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
            <div>Account Name</div>
            <div class="postfix-icon-padding">
              {{formControlStep2CustomerAccountName.value}}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
            <div>Financial Institution Name</div>
            <div class="postfix-icon-padding">
              {{formControlStep2CustomerFinancialInstitutionName.value}}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
            <div>BSB</div>
            <div class="postfix-icon-padding">
              {{formControlStep2CustomerBsb.value}}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
            <div>Account Number</div>
            <div class="postfix-icon-padding">
              {{formControlStep2CustomerAccountNumber.value}}
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="mat-subtitle-1 header">Broker Bank Details</div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
            <div>Account Name</div>
            <div class="postfix-icon-padding">
              {{formControlStep2BrokerAccountName.value}}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
            <div>Financial Institution Name</div>
            <div class="postfix-icon-padding">
              {{formControlStep2BrokerFinancialInstitutionName.value}}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
            <div>BSB</div>
            <div class="postfix-icon-padding">
              {{formControlStep2BrokerBsb.value}}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="account-item" fxLayoutGap="10px" fxLayoutAlign="space-between center">
            <div>Account Number</div>
            <div class="postfix-icon-padding">
              {{formControlStep2BrokerAccountNumber.value}}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 3: Account Action Success
##########################################
-->
<ng-template #step3>
  <div class="step3">
    <form [formGroup]="formGroupStep3">
      <div class="row">
        <div class="col-12" fxLayoutGap="10px" fxLayoutAlign="center center">
          @if (apiError) {
            <div class="error-icon">
              <span class="mdi mdi-alert-circle"></span>
            </div>
          } @else {
            <div class="success-icon">
              <span class="mdi mdi-file-sign"></span>
            </div>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-12" fxLayoutGap="10px" fxLayoutAlign="center center">
          @if (apiError) {
            <div class="mat-subtitle-1 error-text">Something went wrong</div>
          } @else {
            <div class="mat-subtitle-1">{{getSuccessMessage()}}</div>
          }
        </div>
      </div>
      @if (apiError) {
        <div class="row">
          <div class="col-12 text-center">
            <span class="error-message">{{apiErrorMessage}}</span>
          </div>
        </div>
      } @else if (hasFailedFees()) {
        <div class="row mt-3">
          <div class="col-12">
            <message-box-2 type="warn" title="Partial Success" 
              subTitle="The main action was successful, but some secondary tasks (like fee posting) failed. Please review the following:">
              <ul class="failed-fees-list">
                @for (fee of getFailedFeesList(); track fee) {
                  <li>{{fee}}</li>
                }
              </ul>
            </message-box-2>
          </div>
        </div>
      }
    </form>
  </div>
</ng-template>


